import { Selection, axisBottom, axisLeft, axisRight, axisTop } from 'd3';
import Axis from '../Base/axis';

type SvgEl = Selection<SVGGElement, unknown, HTMLElement, any>;
interface DrawAxOptions {
  translate: string;
}

/**
 * Given an svg element and an axis instance, draws
 * an axis on the svg with respect to the axis scale and preferred orientation
 * @param svg
 * @param axis
 * @returns
 */
export function drawAxis(svg: SvgEl, axis: Axis, opts?: DrawAxOptions) {
  const scale = axis.scale;
  let orienter = axisBottom;

  const t = opts?.translate || 'translate(0, 0)';

  if (axis.loc === 'left') orienter = axisLeft;
  if (axis.loc === 'right') orienter = axisRight;
  if (axis.loc === 'top') orienter = axisTop;

  if (axis.loc === 'bottom') {
    return svg.append('g').attr('transform', t).call(orienter(scale));
  }

  const el = svg.append('g').call(orienter(scale));
  return el;
}

export function drawAxisLabels(sel: SvgEl, axis: Axis) {
  if (!axis.labels.visible) {
    sel.selectAll('text').style('display', 'none');
    return sel;
  }
}
